export default {
  title: 'Aktualisiere die Abgabezeit',
  labels: {
    dropoff_time: 'Abgabezeit',
    confirmed: 'Bestätigte Zeit:',
    new_time: 'Neue Zeit:',
  },
  buttons: {
    save: 'Speichern',
  },
  toasts: {
    success: 'Die Abgabezeit wurde erfolgreich aktualisiert',
    failed_to_save: 'Änderungen konnten nicht gespeichert werden',
  },
  alerts: {
    dropoff_time_info:
      'Sowohl die aktuelle Zeit als auch die neue Zeit befinden sich in der Zeitzone {{timezone}} von {{restaurantName}}.',
  },
};
